/* Balkan — raftul de recomandări din sertarul de coș (6 oct. 2026).
 *
 * Cere secțiunea `balkan-cart-reco` prin endpoint-ul de recomandări al lui
 * Shopify, pe baza primului produs din coș, și o injectează între lista de
 * produse și sumar.
 *
 * ⚠️ Se reîmprospătează la fiecare schimbare de coș: Horizon re-randează
 * sertarul din server, deci nodul injectat dispare. De-aia nu e de ajuns o
 * singură rulare la încărcare — urmărim DOM-ul.
 */
(() => {
  if (window.__bkCartReco) return;
  window.__bkCartReco = true;

  const GAZDA = '[data-bk-creco]';
  let ultimaCheie = null;
  let inCurs = false;

  const cheieCos = (gazda) => gazda.getAttribute('data-bk-creco') || '';

  async function incarca(gazda) {
    const pid = cheieCos(gazda);
    /* Coș gol sau fără id de produs: nu avem pe ce baza recomandarea. */
    if (!pid) { gazda.innerHTML = ''; return; }
    if (inCurs) return;
    inCurs = true;
    try {
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = `${base}recommendations/products?section_id=balkan-cart-reco`
        + `&product_id=${encodeURIComponent(pid)}&limit=10&intent=related`;
      const r = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!r.ok) { gazda.innerHTML = ''; return; }
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const bloc = doc.querySelector('.bk-creco');
      gazda.innerHTML = '';
      if (bloc) {
        gazda.appendChild(bloc);
        sageti(bloc);
        /* `balkan-rail.js` se leagă singur la `.bk-rail` prin MutationObserver,
           dar îl anunțăm explicit ca să nu depindem de ordinea de încărcare. */
        document.dispatchEvent(new CustomEvent('bk:rail:refresh'));
      }
      ultimaCheie = pid;
    } catch { gazda.innerHTML = ''; }
    finally { inCurs = false; }
  }

  /* Săgețile ‹ › din antet (referința clientului). Derulează raftul cu un card
     plus spațiul dintre ele și se dezactivează la capete, ca să nu rămână un
     buton care nu face nimic. Tragerea cu mouse-ul rămâne — o dă `balkan-rail.js`. */
  function sageti(bloc) {
    const raft = bloc.querySelector('[data-bk-creco-rail]');
    const prev = bloc.querySelector('[data-bk-creco-prev]');
    const next = bloc.querySelector('[data-bk-creco-next]');
    if (!raft || !prev || !next) return;

    const pas = () => {
      const card = raft.querySelector('.bk-mini');
      if (!card) return raft.clientWidth;
      const gap = parseFloat(getComputedStyle(raft).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };
    const starea = () => {
      const max = raft.scrollWidth - raft.clientWidth - 1;
      prev.disabled = raft.scrollLeft <= 0;
      next.disabled = raft.scrollLeft >= max;
    };
    prev.addEventListener('click', () => raft.scrollBy({ left: -pas(), behavior: 'smooth' }));
    next.addEventListener('click', () => raft.scrollBy({ left: pas(), behavior: 'smooth' }));
    raft.addEventListener('scroll', starea, { passive: true });
    starea();
  }

  function verifica() {
    const gazda = document.querySelector(GAZDA);
    if (!gazda) return;
    const pid = cheieCos(gazda);
    if (pid === ultimaCheie && gazda.children.length) return;
    if (pid !== ultimaCheie) ultimaCheie = null;
    incarca(gazda);
  }

  /* ⚠️ PERFORMANȚĂ (15 oct. 2026): doar la ELEMENTE noi (sertarul randat de temă),
     o dată pe cadru — nu la fiecare schimbare de text din pagină. */
  let programat = false;
  /* și la elemente SCOASE: un produs șters din coș schimbă cheia coșului */
  const cuElemente = (m) => {
    if (m.type === 'attributes') return true; // cheia coșului schimbată pe loc
    for (const n of m.addedNodes) if (n.nodeType === 1) return true;
    for (const n of m.removedNodes) if (n.nodeType === 1) return true;
    return false;
  };
  new MutationObserver((muts) => {
    if (programat || !muts.some(cuElemente)) return;
    programat = true;
    requestAnimationFrame(() => { programat = false; verifica(); });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bk-creco'] });
  document.addEventListener('DOMContentLoaded', verifica);
  verifica();
})();
